import { Injectable } from '@angular/core';
import { Access } from '../interfaces/access.interface';
import { ApiResponse } from '../interfaces/api-response.interface';
import { AppHttpService } from './app-http.service';
import { AccessService } from './access.service';
import { environment } from '../../../environments/environment';
import { IUserAccess, Profile, User } from '../models/user.model';
import { Router } from '@angular/router';
import { ActiveSubscription } from '../../subscription/models/active-subscription';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user!: User | undefined;
  profilePicture: string = '';
  private activeSubscription : ActiveSubscription | undefined;

  constructor(
    private http: AppHttpService,
    private accessService: AccessService,
    private router: Router
  ) {}

  /**
   * get user details
   *
   * @return {*}  {(User | undefined)}
   * @memberof UserService
   */
  getUser(): User | undefined {
    return this.user;
  }

  /**
   * Get user profile details
   *
   * @return {*}
   * @memberof UserService
   */
  async getUserWithAccessDetails(): Promise<any> {
    const response: ApiResponse<IUserAccess> = await this.http.get(
      'auth/user-access',
    );
    if (response.status) {
      const userAccess = response.data!;
      //this.setUserDetails(profile.user);
      this.http.setAccessList(userAccess.accessList ?? []);
      this.accessService.setAccess(userAccess.accessList ?? []);
      this.accessService.setUserAccess(userAccess.accessIds ?? []);
      this.user = userAccess.user;
      this.activeSubscription = userAccess.subscription;
      return userAccess;
    } else {
      return null;
    }
  }

  /**
   * set User details
   *
   * @param {User} user
   * @memberof UserService
   */
  setUserDetails(user: User) {
    this.user = user;
  }

  /**
   * Clear user details
   *
   * @memberof UserService
   */
  clearUserDetails() {
    this.user = undefined;
  }

  hasActiveSubscription(){
    return !!this.activeSubscription;
  }

  getActiveSubscription(){
    return this.activeSubscription;
  }

  handleSUbscription(){
    if(!this.activeSubscription){
      this.router.navigate(['/subscription']);
    }
  }
}
